import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import api from '../../services';
import { storeTenantBranding, readTenantBranding } from '../../utils/tenantBrandingCache';
import { applyTenantBrandingCssVars } from '../../utils/tenantThemeCssVars';

/**
 * Loads tenant/org branding from the API after login so PDFs (which read cached branding)
 * use the saved organization settings without opening Settings first.
 */
export default function TenantBrandingBootstrap() {
  const authUser = useSelector((state) => state.Auth.authUser);

  useEffect(() => {
    applyTenantBrandingCssVars(readTenantBranding());
  }, []);

  useEffect(() => {
    if (!authUser) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/tenant/settings');
        if (!cancelled && data) {
          storeTenantBranding(data);
          applyTenantBrandingCssVars(data);
        }
      } catch (_) {
        /* offline / stale session — PDFs fall back to cache or Ace defaults */
        if (!cancelled) applyTenantBrandingCssVars(readTenantBranding());
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authUser]);

  return null;
}
